import React, { useMemo } from "react";
import { Grid } from "@mui/material";
import SkillFrameworkItem from "./SkillFrameworkItem";
import { compareByLevelExperienceAndDisplayName } from "../../utils/sortSkills";

/**
 * フレームワーク / ライブラリ一覧表示
 *
 * - スマホ（xs）：1行に2つ
 * - タブレット以上（sm〜）：1行に4つ
 */
const SkillFrameworkList = ({ frameworks = [], owner, showEditButton }) => {
  const sortedFrameworks = useMemo(() => {
    const normalizedFrameworks = Array.isArray(frameworks) ? frameworks : [];
    return [...normalizedFrameworks].sort(
      compareByLevelExperienceAndDisplayName,
    );
  }, [frameworks]);

  return (
    <Grid container spacing={2} justifyContent="flex-start">
      {sortedFrameworks.map((framework) => (
        <Grid
          item
          key={framework.recordId || framework.displayName}
          xs={6}
          sm={3}
        >
          <SkillFrameworkItem
            framework={framework}
            owner={owner}
            showEditButton={showEditButton}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default SkillFrameworkList;
